"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var styles_1 = require("@material-ui/core/styles");
var styles = function (_a) {
    var spacing = _a.spacing;
    return styles_1.createStyles({
        container: {
            listStyleType: 'none',
            padding: 0,
            margin: 0,
        },
    });
};
exports.styles = styles;
